import { render, staticRenderFns } from "./SupplierProductInformation.vue?vue&type=template&id=101a55f5&scoped=true"
import script from "./SupplierProductInformation.vue?vue&type=script&lang=js"
export * from "./SupplierProductInformation.vue?vue&type=script&lang=js"
import style0 from "./SupplierProductInformation.vue?vue&type=style&index=0&id=101a55f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101a55f5",
  null
  
)

export default component.exports